/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Row, Modal, Tooltip, Skeleton, Spin } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined,
  PrinterFilled,
  //   BarcodeOutlined,
} from "@ant-design/icons";
import "./index.css";
import { useHistory } from "react-router";
// import moment from "moment";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  deleteExpensesList,
  loadExpensesList,
} from "../../store/expenses/actions";
import html2canvas from "html2canvas";
import { ToWords } from "to-words";
import jsPDF from "jspdf";
import ReactToPrint from "react-to-print-advanced";
import useMedia from "use-media-antd-query";
import moment from "moment";
import "jspdf-autotable";

const ExpensesPreview = (props) => {
  const [loading, setLoading] = useState(false);
  const [expensePrint, setExpensePrint] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const media = useMedia();
  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";

  const orgList = { organizationId: userInfoDetails };

  //partys tabs

  //Props values from parties home

  const itemList =
    props.location && props.location.state ? props.location.state.data : "";
  // const location = window.location.href;

  const expenseInvoiceData =
    props.location && props.location.state ? props.location.state.data : "";
  const expenseInvoiceDate =
    expenseInvoiceData && expenseInvoiceData.expenseDate
      ? moment(expenseInvoiceData.expenseDate).format("DD-MM-YYYY")
      : "";

  console.log(expenseInvoiceData, "expenseInvoiceData");
  console.log(expenseInvoiceDate, "expenseInvoiceDate");

  //api loader
  useEffect(() => {
    dispatch(loadExpensesList(orgList));
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state

  const [pageRouting, setPageRouting] = useState(false);
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);
  const history = useHistory();

  //category api integrations
  const [deleteExpenseModal, setExpenseDeleteModal] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  //deletPurchase api integrations
  const deleteExpensesInvoice = () => {
    setIsButtonDisabled(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 4000);
    const itemListData = {
      organizationId: userInfoDetails,
      expenseId: expenseInvoiceData._id,
      deletedBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    };
    dispatch(deleteExpensesList(itemListData));
    // console.log(itemListData, "itemListData");
    setTimeout(() => {
      dispatch(loadExpensesList(orgList));
      setExpenseDeleteModal(false);
      setTimeout(() => {
        history.push("/expenses");
      }, 1000);
      toast.error("Expenses deleted successfully");
    }, 1000);
  };

  //Ledger statement section
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);

    const detectDevTools = () => {
      const threshold = 160; // Adjust based on browser behavior
      const widthThreshold = window.outerWidth - window.innerWidth > threshold;
      const heightThreshold =
        window.outerHeight - window.innerHeight > threshold;

      setIsDevToolsOpen(widthThreshold || heightThreshold);
    };

    const interval = setInterval(detectDevTools, 500); // Check every 500ms
    return () => clearInterval(interval);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  console.log(isDevToolsOpen, "isDevToolsOpen");
  const toWords = new ToWords();

  // const [downloadLoading, setDownloadLoading] = useState(false);

  //download pdf
  const handleDownloadPDF = async () => {
    const input = document.getElementById("pdf-content");
    // Specify the id of the element you want to convert to PDF
    // setDownloadLoading(true);

    setDownloadLoading(true);
    setTimeout(() => {
      setDownloadLoading(false);
    }, 2000);
    const pdfWidth =
      windowDimensions.width < 767 ? 120 : isDevToolsOpen ? 148 : 215; // A4 width is 210mm
    const pdfHeight = 237; // A4 height in mm
    // const padding = 20; // Padding in mm
    setTimeout(() => {
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL("image/png", 2);
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: [pdfWidth, pdfHeight],
        });
        // pdf.rect(
        //   padding,
        //   padding,
        //   pdfWidth - 2 * padding,
        //   pdfHeight - 2 * padding
        // );
        pdf.addImage(imgData, "PNG", 5, 10);
        pdf.save("expenses-invoice.pdf");
        // setDownloadLoading(false);
        // Specify the name of the downloaded PDF file
      });
    }, 1200);
    // const doc = new jsPDF();
    // const padding = 10; // Global padding
    // const pageWidth = doc.internal.pageSize.getWidth();
    // const pageHeight = doc.internal.pageSize.getHeight();
    // // === Draw Full Outer Border ===
    // doc.rect(
    //   padding,
    //   padding,
    //   pageWidth - 2 * padding,
    //   pageHeight - 2 * padding
    // ); // Full border
    // // Draw Title
    // doc.setFontSize(16);
    // doc.setFont("helvetica", "bold");
    // doc.text("Expense Estimate", 105, 20, { align: "center" });

    // // === BILL FROM & INVOICE INFO SECTION ===
    // doc.setFontSize(10);
    // doc.setFont("helvetica", "normal");

    // // Outer Rectangle
    // doc.rect(padding, 25, 190, 20);

    // // Left Section - BILL FROM
    // doc.text("BILL FROM:", padding + 2, 32);
    // doc.setFont("helvetica", "bold");
    // doc.text("Santhosh S", padding + 2, 40);

    // // Right Section - Invoice Details
    // doc.line(105, 25, 105, 45); // Vertical Divider

    // doc.setFont("helvetica", "normal");
    // doc.text("Invoice No:", 110, 32);
    // doc.text("6", 135, 32);

    // doc.text("Invoice Date:", 110, 40);
    // doc.text("24-01-2025", 135, 40);

    // // === ITEM TABLE HEADER ===
    // const startY = 45;
    // const colWidths = [15, 40, 30, 25, 20, 30, 30]; // Column Widths
    // const colTitles = [
    //   "S.NO",
    //   "ITEM NAME",
    //   "PRICE",
    //   "DISCOUNT",
    //   "QTY",
    //   "TAX AMOUNT",
    //   "AMOUNT",
    // ];
    // let currentY = startY + 10;
    // const rowHeight = 10;
    // // === DYNAMIC ROW DATA ===
    // const rowData =
    //   expenseInvoiceData && expenseInvoiceData.expenseItem.length > 0
    //     ? expenseInvoiceData.expenseItem
    //     : [];

    // let xPos = padding;

    // const tableRows = rowData.map(
    //   (item, index) => (
    //     index + 1,
    //     item.expenseItemName,
    //     `$${item.priceofItem}`,
    //     `$${item.discountAmount}`,
    //     `$${item.qty}`,
    //     `$${item.taxableAmount}`,
    //     `$${(item.qty * item.priceofItem).toFixed(2)}`
    //   )
    // );

    // // Add table to PDF
    // doc.autoTable({
    //   startY: 50,
    //   head: [colTitles],
    //   body: tableRows,
    //   styles: { halign: 'center', valign: 'middle' },
    //   headStyles: { fillColor: [200, 200, 200] },
    // });
    // // rowData.forEach((row) => {
    // //   let currentX = padding;
    // //   row.forEach((cell, index) => {
    // //     doc.rect(currentX, currentY, colWidths[index], 10); // Draw cell box
    // //     doc.text(cell, currentX + 2, currentY + 7); // Cell content
    // //     currentX += colWidths[index];
    // //   });
    // //   currentY += 10; // Move to the next row
    // // });
    // const taxableTotalAmount = rowData.flatMap((data) =>
    //   data.priceofItem && data.taxableAmount
    //     ? parseInt(data.priceofItem + data.taxableAmount)
    //     : data.priceofItem
    // );
    // const totalAmount = rowData.flatMap((data) =>
    //   isEmpty(data.discountAmount)
    //     ? data.qty * taxableTotalAmount
    //     : data.qty * (taxableTotalAmount - data.discountAmount)
    // );
    // const totalQty = totals && totals.qty ? totals.qty : "";

    // const totalAmountInWords =
    //   totals && totals.totalAmount !== 0
    //     ? "₹ " + totals.totalAmount.toLocaleString("en-IN")
    //     : expenseInvoiceData.itemsTotalAmount
    //     ? "₹ " + expenseInvoiceData.itemsTotalAmount.toLocaleString("en-IN")
    //     : "₹ " + 0;
    // // === TOTAL SECTION ===
    // const totalAmountWidth = colWidths[colWidths.length - 1]; // Match with 'AMOUNT' column
    // const labelWidth = pageWidth - 2 * padding - totalAmountWidth;

    // doc.rect(padding, currentY, labelWidth, rowHeight);
    // doc.text("TOTAL", padding + labelWidth - 20, currentY + 7);

    // doc.rect(padding + labelWidth, currentY, totalAmountWidth, rowHeight);
    // doc.text(`Rs. ${totalQty}`, padding + labelWidth + 5, currentY + 7);
    // doc.rect(padding + labelWidth, currentY, totalAmountWidth, rowHeight);
    // doc.text(`Rs. ${totalAmount}`, padding + labelWidth + 5, currentY + 7);

    // doc.rect(padding, currentY, labelWidth, rowHeight);
    // doc.text("Net Amount", padding + labelWidth - 20, currentY + 7);

    // doc.rect(padding + labelWidth, currentY, totalAmountWidth, rowHeight);
    // doc.text(`Rs. ${totalAmount}`, padding + labelWidth + 5, currentY + 7);

    // currentY += 15;

    // // === TOTAL AMOUNT IN WORDS ===
    // // Outer Rectangle
    // doc.rect(padding, 25, 190, 20);
    // doc.setFont("helvetica", "bold");
    // doc.text("Total Amount (in words):", padding, currentY);
    // doc.text(`${totalAmountInWords}`, padding, currentY);
    // // Save the PDF
    // doc.save("Expense - invoice.pdf");
  };

  //Calculate totals
  const calculateTotals = (rows) => {
    let qty = 0;
    let totalAmount = 0;

    rows.forEach((row) => {
      qty += parseFloat(row.qty) || 0;
      totalAmount += row.taxableAmount
        ? parseFloat(row.qty * row.priceofItem) + row.taxableAmount
        : parseFloat(row.qty * row.priceofItem) || 0;
    });

    return { qty, totalAmount };
  };

  const [totals, setTotals] = React.useState({
    qty: 0,
    totalAmount: 0,
  });

  useEffect(() => {
    if (expenseInvoiceData && expenseInvoiceData.expenseItem.length > 0) {
      const total = calculateTotals(expenseInvoiceData.expenseItem);
      setTotals(total);
    }
  }, [expenseInvoiceData]);

  const additionalTotal =
    expenseInvoiceData.additionalAmount !== ""
      ? parseFloat(totals.totalAmount + expenseInvoiceData.additionalAmount)
      : totals.totalAmount;
  const netAmount =
    totals.totalAmount &&
    expenseInvoiceData &&
    expenseInvoiceData.discountAmount !== "" &&
    expenseInvoiceData.additionalAmount !== ""
      ? parseFloat(additionalTotal - expenseInvoiceData.discountAmount)
      : totals.totalAmount &&
        expenseInvoiceData &&
        expenseInvoiceData.discountAmount !== "" &&
        expenseInvoiceData.additionalAmount == ""
      ? parseFloat(totals.totalAmount - expenseInvoiceData.discountAmount)
      : totals.totalAmount &&
        expenseInvoiceData &&
        expenseInvoiceData.discountAmount === "" &&
        expenseInvoiceData.additionalAmount !== ""
      ? parseFloat(additionalTotal)
      : totals.totalAmount;

  const netAmountFinal =
    totals &&
    totals.totalAmount &&
    netAmount &&
    expenseInvoiceData.itemsTotalDiscount !== ""
      ? (Number(netAmount) - Number(expenseInvoiceData.itemsTotalDiscount))
          .toFixed(2)
          .toLocaleString("en-IN")
      : totals &&
        totals.totalAmount &&
        netAmount &&
        expenseInvoiceData.itemsTotalDiscount === ""
      ? parseFloat(netAmount).toFixed(2).toLocaleString("en-IN")
      : totals &&
        totals.totalAmount &&
        expenseInvoiceData.itemsTotalDiscount !== ""
      ? (
          Number(totals.totalAmount) -
          Number(expenseInvoiceData.itemsTotalDiscount)
        )
          .toFixed(2)
          .toLocaleString("en-IN")
      : totals &&
        totals.totalAmount &&
        expenseInvoiceData.itemsTotalDiscount === ""
      ? parseFloat(totals.totalAmount).toFixed(2).toLocaleString("en-IN")
      : 0;

  console.log(netAmount, "netAmount");
  console.log(netAmountFinal, "netAmountFinal");

  const expenseInvoiceRef = useRef();

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //totals
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Expenses | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm">
        <Col span={24}>
          <Row>
            <Col span={24}>
              <Row>
                <Col
                  span={24}
                  className="bg-[#ffffff] border border-b-1 border-x-0 border-t-0 pb-2"
                >
                  <div
                    className={
                      media === "sm" || media === "xs"
                        ? "font-poppins flex flex-col pl-[20px] pr-[20px] mt-2"
                        : "font-poppins flex justify-between pl-[20px] pr-[20px] mt-2"
                    }
                  >
                    <div className="flex">
                      <ArrowLeftOutlined
                        onClick={() => setPageRouting(true)}
                        className="font-bold text-[18px]"
                      />
                      <h1
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className={
                          media === "sm" || media === "xs"
                            ? "text-[16px] ml-2 mt-1 font-semibold"
                            : "text-[18px] ml-2 mt-1 font-semibold"
                        }
                      >
                        {"Expense invoice "}
                        {expenseInvoiceData
                          ? expenseInvoiceData.purchaseinvoiceNo
                          : ""}
                      </h1>
                      {/* <Badge
                        className={
                          billStatus === 1
                            ? "bg-[#edf6ef] font-semibold rounded-md text-[#49a563] h-[30px] mt-1 p-2 ml-4"
                            : billStatus === 3
                            ? "bg-[#ebc951e0] font-semibold rounded-md text-[white] h-[30px] mt-1 p-2 ml-4"
                            : "bg-[#f1e7e9] font-semibold rounded-md text-[#d01717] h-[30px] mt-1 p-2 ml-4"
                        }
                      >
                        {billStatusName}
                      </Badge> */}
                    </div>

                    <div
                      className={
                        media === "sm" || media === "xs" ? "flex mt-2" : "flex"
                      }
                    >
                      <Tooltip
                        title="Edit Expense invoice"
                        placement="left"
                        rootClassName="text-[10px]"
                      >
                        <div
                          onClick={() => {
                            history.push({
                              pathname: "/create-expenses",
                              state: {
                                expenseInvoiceData: expenseInvoiceData
                                  ? expenseInvoiceData
                                  : "",
                                organizationId: userInfoDetails,
                                userId:
                                  !isEmpty(userNameDetails) &&
                                  userNameDetails.user._id,
                                itemList: itemList,
                              },
                            });
                          }}
                          className="border flex rounded-md justify-between  pl-3 pr-1 pt-1 pb-1 ml-3  cursor-pointer"
                        >
                          <EditOutlined className="text-[18px] pr-3" />
                          {media === "sm" || media === "xs" ? (
                            <p
                              style={{
                                fontFamily: "Poppins",
                                paddingLeft: "2px",
                              }}
                              onClick={() => {
                                history.push({
                                  pathname: "/create-expenses",
                                  state: {
                                    expenseData: expenseInvoiceData
                                      ? expenseInvoiceData
                                      : "",
                                    organizationId: userInfoDetails,
                                    // userId: userId,
                                    itemList: itemList,
                                  },
                                });
                              }}
                            >
                              Edit
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </Tooltip>
                      <Tooltip
                        title="Delete This Purchase"
                        placement="bottom"
                        rootClassName="text-[10px]"
                      >
                        <div
                          onClick={() => setExpenseDeleteModal(true)}
                          className="border border-1 flex border-red-200 text-[red] rounded-md ml-3 pl-3 pr-3 pt-1 pb-1 cursor-pointer"
                        >
                          <DeleteOutlined />
                          {media === "sm" || media === "xs" ? (
                            <p
                              style={{
                                fontFamily: "Poppins",
                                paddingLeft: "4px",
                              }}
                            >
                              Delete
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </Col>

                <Col span={24} className="pl-4 pt-4 pb-4 pr-1 bg-[#ffffff]">
                  <Row>
                    <Col span={20}>
                      <Row>
                        <Col md={8} lg={6} sm={24} xs={24} className="pr-3">
                          {loading ? (
                            <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                          ) : (
                            <div
                              style={{
                                fontFamily: "Poppins",
                              }}
                              onClick={handleDownloadPDF}
                              className="cursor-pointer flex border flex justify-center pt-2 pb-2 pl-2 pr-4 rounded-md border-1 track-wider text-start lg:text-center xl:text-center"
                            >
                              {downloadLoading ? (
                                <p className="flex">
                                  <Spin className="mr-2" /> Downloading
                                </p>
                              ) : (
                                <div className="flex">
                                  <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                  Download
                                </div>
                              )}
                            </div>
                          )}
                        </Col>
                        <Col
                          md={8}
                          lg={6}
                          sm={24}
                          xs={24}
                          className={
                            media === "xs" || media === "sm"
                              ? "pr-3 mt-2"
                              : "pr-3"
                          }
                        >
                          {loading ? (
                            <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                          ) : (
                            <div
                              className="cursor-pointer w-[100%]"
                              onClick={() => {
                                setExpensePrint(true);
                                setTimeout(() => {
                                  setExpensePrint(false);
                                }, 4000);
                              }}
                            >
                              <ReactToPrint
                                trigger={() => (
                                  <div
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className=" track-wider flex border justify-center pt-2 pb-2 pl-2 pr-4 rounded-md border-1 text-start lg:text-center xl:text-center"
                                  >
                                    {expensePrint ? (
                                      <p className="flex">
                                        <Spin className="mr-2" /> Loading
                                      </p>
                                    ) : (
                                      <div className="flex">
                                        <PrinterFilled className="cursor-pointer text-[16px] mr-3" />
                                        Print Receipt
                                      </div>
                                    )}
                                  </div>
                                )}
                                delay={1500}
                                content={() => expenseInvoiceRef.current}
                              />
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col
                  span={24}
                  className={
                    (windowDimensions.height >= 700 &&
                      windowDimensions.height <= 767) ||
                    (windowDimensions.height > 767 &&
                      windowDimensions.height < 830)
                      ? "add-purchase-main-large-device mt-3"
                      : windowDimensions.height > 830 &&
                        windowDimensions.height < 900
                      ? "add-purchase-main-extra-large-device mt-3"
                      : windowDimensions.height > 900 &&
                        windowDimensions.height < 1000
                      ? "add-purchase-main-extra-extra-large-device mt-3"
                      : windowDimensions.height > 1000
                      ? "add-purchase-main-extra-infinite-device mt-3"
                      : "add-purchase-main mt-3"
                  }
                >
                  <Row className="flex justify-center">
                    <Col span={media === "xxl" ? 14 : 20} className="mb-4 pb-6">
                      <div
                        className={
                          downloadLoading
                            ? "rounded-sm bg-[#ffffff] pb-3 pl-8 pr-12 mb-3"
                            : "rounded-sm bg-[#ffffff] pb-3 pl-8 pr-8 mb-3"
                        }
                      >
                        <Row>
                          {/* <Col span={24} className="pb-3 mt-5 ml-4">
                            <h1 className="text-[12px] font-semibold mt-2 party-label">
                              {(downloadLoading || expensePrint) && location
                                ? location
                                : ""}
                            </h1>
                          </Col> */}
                          <Col span={24} className="pb-3 mt-5 ml-4">
                            <h1 className="text-[14px] font-semibold uppercase mt-2 party-label">
                              {expenseInvoiceData
                                ? expenseInvoiceData.transActionType
                                : ""}
                            </h1>
                          </Col>
                        </Row>
                        <Row
                          className={
                            expensePrint
                              ? "flex bg-[#ffffff] justify-center ml-5 mr-5 mt-8 mb-4"
                              : !expensePrint && downloadLoading
                              ? "flex bg-[#ffffff] justify-center ml-[20px] w-[91%] mt-5 mb-4"
                              : "flex bg-[#ffffff] justify-center ml-3 mr-4 mt-2 mb-4"
                          }
                          style={{
                            border: "1px solid black",
                          }}
                          id="pdf-content"
                          ref={expenseInvoiceRef}
                        >
                          <Col
                            md={24}
                            className={
                              "pt-4 pb-4 border-solid rounded-sm bg-[#ffffff]"
                            }
                          >
                            <Row>
                              <Col span={24} className="pb-3 pt-3 text-center">
                                <div
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="w-[100%] p-2"
                                >
                                  <p className="party-label">
                                    <p className="text-[18px] text-center font-semibold capitalize">
                                      {/* {userOrganisationName
                                        ? userOrganisationName
                                        : ""} */}
                                      Expense Estimate
                                    </p>
                                  </p>
                                  {/* <p className="party-label">
                                    <p className="text-[13px] text-center font-semibold mr-2">
                                      Mobile:
                                    </p>
                                    <p className="text-[13px]">
                                      {expenseInvoiceData
                                        ? expenseInvoiceData.vendorMobileNo
                                        : ""}
                                    </p>
                                  </p> */}
                                </div>
                              </Col>
                              <Col
                                span={24}
                                style={{
                                  border: "1px solid black",
                                  borderLeft: "none",
                                  borderRight: "none",
                                  borderBottom: expensePrint
                                    ? "1px solid black"
                                    : "1px solid black",
                                }}
                              >
                                <Row>
                                  <Col
                                    md={11}
                                    sm={24}
                                    lg={11}
                                    xs={24}
                                    style={{
                                      borderRight: expensePrint
                                        ? ""
                                        : "1px solid black",
                                      borderBottom: expensePrint
                                        ? "1px solid black"
                                        : "",
                                    }}
                                  >
                                    <div className="p-4 pt-3 pb-3">
                                      <h1 className="purchase-label text-[12px] font-semibold mr-3 uppercase">
                                        Bill From:
                                      </h1>
                                      <p className="mt-1 text-[14px] purchase-label font-semibold">
                                        {expenseInvoiceData
                                          ? expenseInvoiceData.partyName
                                          : ""}
                                      </p>
                                      {/* <p className="mt-1 text-[12px] purchase-label">
                                        Address:{" "}
                                        {vendorAddress
                                          ? vendorAddress.address1 +
                                            ", " +
                                            vendorAddress.city +
                                            ", " +
                                            "Tamil Nadu" +
                                            // vendorAddress.vendorStateName || "" +
                                            " - " +
                                            vendorAddress.pincode
                                          : ""}
                                      </p> */}
                                    </div>
                                  </Col>
                                  <Col
                                    md={13}
                                    sm={24}
                                    lg={13}
                                    xs={24}
                                    style={{
                                      borderBottom: expensePrint
                                        ? "1px solid black"
                                        : "",
                                    }}
                                  >
                                    <Row className="w-[100%] flex justify-between pl-8 pr-5 pt-6 pb-6">
                                      <div className="w-[33%]">
                                        <h1 className="purchase-label text-[12px] font-semibold mr-3">
                                          Invoice No:
                                        </h1>
                                        <p className="mt-[-2px]">
                                          {expenseInvoiceData.expenseNo}
                                        </p>
                                      </div>
                                      <div className="w-[33%]">
                                        <h1 className="purchase-label text-[12px] font-semibold mr-3">
                                          Invoice Date:
                                        </h1>
                                        <p className="mt-[-2px]">
                                          {expenseInvoiceDate}
                                        </p>
                                      </div>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                              {/* PO statement */}
                              <Col span={24} className="add-create-item-table">
                                <table
                                  className={`${
                                    media === "xxl"
                                      ? "mb-[7.5rem]"
                                      : "mb-[5rem]"
                                  } table-purchase-serial table-responsive`}
                                >
                                  <thead>
                                    <tr className="table-activities-head-main">
                                      <th className="w-[5%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        S.No
                                      </th>
                                      <th className="w-[20%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Item Name
                                      </th>
                                      <th className="w-[20%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Price
                                      </th>
                                      <th className="w-[20%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Discount
                                      </th>
                                      <th className="w-[10%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Qty
                                      </th>
                                      <th className="w-[15%] uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Tax Amount
                                      </th>
                                      <th className="w-[20%] uppercase text-end table-sales-invoice-print-main-head text-[12px] font-semibold">
                                        Amount
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="mb-8">
                                    {expenseInvoiceData &&
                                    expenseInvoiceData.expenseItem &&
                                    expenseInvoiceData.expenseItem.length > 0
                                      ? expenseInvoiceData.expenseItem.map(
                                          (data, index) => {
                                            const priceOfItemValue = parseFloat(
                                              data.qty * data.priceofItem
                                            );
                                            const totalAmount =
                                              data.discountAmount ===
                                                undefined ||
                                              data.discountAmount === ""
                                                ? priceOfItemValue
                                                : parseFloat(
                                                    priceOfItemValue -
                                                      data.discountAmount
                                                  );

                                            console.log(
                                              totalAmount,
                                              "totalAmount"
                                            );
                                            const taxableTotalAmount =
                                              data.priceofItem &&
                                              data.taxableAmount !== undefined
                                                ? parseFloat(
                                                    totalAmount +
                                                      data.taxableAmount
                                                  )
                                                : totalAmount;

                                            console.log(
                                              taxableTotalAmount,
                                              "taxableTotalAmount"
                                            );
                                            return (
                                              <tr
                                                key={index}
                                                className={
                                                  "table-purchase-row border border-b-1 border-x-0 border-t-0"
                                                }
                                              >
                                                <td
                                                  className={
                                                    "table-activities-purchase-data p-2"
                                                  }
                                                >
                                                  {index + 1}
                                                </td>
                                                <td
                                                  className={
                                                    "table-activities-purchase-data p-2"
                                                  }
                                                >
                                                  {data.expenseItemName}
                                                </td>

                                                <td
                                                  className={
                                                    "table-activities-purchase-data p-2"
                                                  }
                                                >
                                                  {data.priceofItem &&
                                                    data.priceofItem.toLocaleString(
                                                      "en-IN"
                                                    )}
                                                </td>
                                                <td
                                                  className={
                                                    "table-activities-purchase-data p-2 text-end"
                                                  }
                                                >
                                                  {data && data.discountAmount
                                                    ? data.discountAmount.toLocaleString(
                                                        "en-IN"
                                                      )
                                                    : 0}
                                                </td>
                                                <td
                                                  className={
                                                    "table-activities-purchase-data p-2"
                                                  }
                                                >
                                                  {data.qty}
                                                </td>
                                                <td
                                                  className={
                                                    "table-activities-purchase-data p-2 text-end"
                                                  }
                                                >
                                                  <div className="flex justify-end">
                                                    <p>
                                                      {data &&
                                                      data.taxableAmount
                                                        ? data.taxableAmount.toLocaleString(
                                                            "en-IN"
                                                          )
                                                        : 0}
                                                    </p>
                                                    <p className="ml-1">
                                                      {data.taxablePercentage ? (
                                                        <p>
                                                          (
                                                          {data.taxablePercentage +
                                                            "%"}
                                                          )
                                                        </p>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </p>
                                                  </div>
                                                </td>
                                                <td
                                                  className={
                                                    "table-sales-invoice-print-data p-2 text-end"
                                                  }
                                                >
                                                  {taxableTotalAmount
                                                    ? taxableTotalAmount.toLocaleString(
                                                        "en-IN"
                                                      )
                                                    : ""}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )
                                      : ""}
                                    <tr
                                      style={{
                                        borderBottom: "1px solid black",
                                        // backgroundColor: "#e7e7e7",
                                      }}
                                      className="font-semibold "
                                    >
                                      <td
                                        colSpan={7}
                                        className="p-[50px] text-end uppercase font-semibold text-[12px]"
                                      ></td>
                                    </tr>
                                    <tr
                                      style={{
                                        borderTop: "1px solid black",
                                        borderBottom: "1px solid black",
                                        // backgroundColor: "#e7e7e7",
                                      }}
                                      className="font-semibold "
                                    >
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td
                                        className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"
                                        // colSpan={2}
                                      >
                                        {"Total"}
                                      </td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]">
                                        {totals && totals.qty ? totals.qty : ""}
                                      </td>
                                      <td
                                        colSpan={2}
                                        className="w-[22%] table-activities-purchase-total-head border-r-0 p-2 text-end"
                                      >
                                        <p className="">
                                          {totals &&
                                          totals.totalAmount !== 0 &&
                                          expenseInvoiceData &&
                                          expenseInvoiceData.itemsTotalDiscount !==
                                            ""
                                            ? "₹ " +
                                              parseFloat(
                                                totals.totalAmount -
                                                  expenseInvoiceData.itemsTotalDiscount
                                              )
                                                .toFixed(2)
                                                .toLocaleString("en-IN")
                                            : totals &&
                                              totals.totalAmount !== 0 &&
                                              expenseInvoiceData &&
                                              expenseInvoiceData.itemsTotalDiscount ==
                                                ""
                                            ? "₹ " +
                                              parseFloat(totals.totalAmount)
                                                .toFixed(2)
                                                .toLocaleString("en-IN")
                                            : expenseInvoiceData &&
                                              expenseInvoiceData.itemsTotalAmount &&
                                              expenseInvoiceData &&
                                              expenseInvoiceData.itemsTotalDiscount !==
                                                ""
                                            ? "₹ " +
                                              parseFloat(
                                                expenseInvoiceData.itemsTotalAmount -
                                                  expenseInvoiceData.itemsTotalDiscount
                                              )
                                                .toFixed(2)
                                                .toLocaleString("en-IN")
                                            : expenseInvoiceData &&
                                              expenseInvoiceData.itemsTotalAmount &&
                                              expenseInvoiceData &&
                                              expenseInvoiceData.itemsTotalDiscount ===
                                                ""
                                            ? "₹ " +
                                              parseFloat(
                                                expenseInvoiceData.itemsTotalAmount
                                              )
                                                .toFixed(2)
                                                .toLocaleString("en-IN")
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        // borderTop: "1px solid black",
                                        borderBottom: "1px solid black",
                                        // backgroundColor: "#e7e7e7",
                                      }}
                                      className="font-semibold "
                                    >
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td className=" text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]">
                                        {"Overall Discount"}
                                      </td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td
                                        colSpan={2}
                                        className=" table-activities-purchase-total-head border-r-0 p-2 text-end"
                                      >
                                        <p className="">
                                          {expenseInvoiceData.discountAmount &&
                                          expenseInvoiceData.discountAmount !=
                                            undefined
                                            ? "₹ " +
                                              expenseInvoiceData.discountAmount.toLocaleString(
                                                "en-IN"
                                              )
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                    </tr>

                                    <tr
                                      style={{
                                        // borderTop: "1px solid black",
                                        borderBottom: "1px solid black",
                                        // backgroundColor: "#e7e7e7",
                                      }}
                                      className="font-semibold "
                                    >
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]">
                                        {"Additional Charges"}
                                      </td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td
                                        colSpan={2}
                                        className="table-activities-purchase-total-head border-r-0 p-2 text-end"
                                      >
                                        <p className="">
                                          {expenseInvoiceData.additionalAmount &&
                                          expenseInvoiceData.additionalAmount !=
                                            undefined
                                            ? "₹ " +
                                              expenseInvoiceData.additionalAmount.toLocaleString(
                                                "en-IN"
                                              )
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        borderBottom: "1px solid black",
                                      }}
                                      className="font-semibold "
                                    >
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>

                                      <td
                                        style={{
                                          fontFamily: "Poppins",
                                        }}
                                        className="uppercase text-[14px] font-semibold table-activities-purchase-total-head p-2 text-end"
                                      >
                                        {"Net Amount"}
                                      </td>
                                      <td className="text-end table-activities-purchase-head uppercase p-2 font-semibold text-[12px]"></td>
                                      <td
                                        colSpan={2}
                                        className="w-[22%] table-activities-purchase-total-head border-r-0 p-2 text-end"
                                      >
                                        <p className="">
                                          {"₹ " + netAmountFinal}
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/* <table className="w-[100%]">
                                  <tbody className="w-[100%]">
                                   
                                  </tbody>
                                </table> */}

                                <Row className="">
                                  <Col
                                    md={24}
                                    style={{
                                      width: expensePrint ? "100%" : "",
                                      //   borderBottom: expensePrint
                                      //     ? "1px solid black"
                                      //     : "",
                                      padding: "10px",
                                    }}
                                  >
                                    <div className="purchase-label">
                                      <h1 className="font-semibold text-start text-[14px]">
                                        Total Amount (in words)
                                      </h1>
                                      <h1 className="mt-1 font-medium text-[12px] text-start">
                                        {totals &&
                                        totals.totalAmount &&
                                        netAmountFinal
                                          ? toWords.convert(netAmountFinal, {
                                              currency: true,
                                              ignoreDecimal: true,
                                            })
                                          : totals &&
                                            totals.totalAmount &&
                                            netAmount
                                          ? toWords.convert(netAmount, {
                                              currency: true,
                                              ignoreDecimal: true,
                                            })
                                          : totals && totals.totalAmount
                                          ? toWords.convert(
                                              totals.totalAmount,
                                              {
                                                currency: true,
                                                ignoreDecimal: true,
                                              }
                                            )
                                          : ""}
                                      </h1>
                                    </div>
                                  </Col>
                                </Row>
                                {/* <Row>
                                  <Col md={24} className="p-2">
                                    <div className="purchase-label">
                                      <h1 className="font-semibold text-[14px]">
                                        Terms and Conditions
                                      </h1>
                                      <p className="text-[12px]">
                                        {expenseInvoiceData
                                          ? expenseInvoiceData.termsandconditions
                                          : ""}
                                      </p>
                                    </div>
                                  </Col>
                                </Row> */}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                    {/* <Col
                      span={3}
                      style={{
                        position: "fixed",
                        top: 214,
                        right: 20,
                      }}
                      className="mb-4 pb-6 ml-[50px]"
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="cursor-pointer border rounded-sm bg-[#ffffff] border-1 flex p-2"
                      >
                        <BsCashCoin className="pr-2" size={22} />
                        Profit Details
                      </div>
                    </Col> */}
                  </Row>
                  <Row className="border border-b-1 border-t-0 border-x-0 flex justify-center mt-3 mb-3"></Row>
                </Col>
              </Row>
            </Col>

            {/* Parties input section with bulk actions */}
          </Row>
        </Col>
      </Row>

      <Modal
        open={pageRouting}
        onOk={() => {
          setPageRouting(false);
          history.push("/expenses");
        }}
        closeIcon
        maskClosable={false}
        rootClassName="p-15 h-[300px]"
        okText={"Yes, Leave"}
        cancelText={"No, Stay"}
        onCancel={() => setPageRouting(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <div className="mr-3">
              <OkBtn />
            </div>
            <CancelBtn />
          </div>
        )}
        width={500}
      >
        <div className="text-center w-[100%]">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to leave this page?
          </h1>
          <p className="text-center text-[14px] mt-2">
            All unsaved changes will be lost!
          </p>
        </div>
      </Modal>

      {/* Delete purchase modal */}

      <Modal
        open={deleteExpenseModal}
        onOk={() => {
          deleteExpensesInvoice();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete Expense Invoice`}
        cancelText={"Cancel"}
        okType="danger"
        okButtonProps={{
          disabled: isButtonDisabled ? true : false,
        }}
        onCancel={() => setExpenseDeleteModal(false)}
        height={300}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div className="text-center w-[100%] p-4">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to delete these expense?
          </h1>
          <p className="text-center text-[14px] mt-2">
            The selected expense will be deleted from the expense Inventory.
            Once deleted you will not be able to restore these expense.
          </p>
        </div>
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

ExpensesPreview.propTypes = {
  location: PropTypes.any,
};

export default ExpensesPreview;
